<template>
  <loading :loading="!coordinates">
    <div v-if="coordinates && coordinates.length === 0">
      <p class="is-light box content">Não há dados de rastreamento.</p>
    </div>
    <div v-else>
      <p class="is-light box content">
        {{ this.trackingTitle }}
      </p>
      <div>
        <vl-map class="map" data-projection="EPSG:4326">
          <vl-view
            ref="view"
            :center.sync="center"
            :rotation.sync="rotation"
            :zoom.sync="zoom"
            ident="view"
          />

          <vl-layer-tile>
            <vl-source-osm />
          </vl-layer-tile>

          <vl-layer-vector v-if="drawType != null" id="draw-pane">
            <vl-source-vector
              :features.sync="drawnFeatures"
              ident="draw-target"
            />
          </vl-layer-vector>

          <vl-feature
            v-if="coordinates && coordinates.length"
            id="position-feature"
          >
            <vl-geom-point :coordinates="coordinates" />
            <vl-style-box>
              <vl-style-icon
                src="https://i.ibb.co/nbtsbjW/marker-red.png"
                :scale="0.3"
                :anchor="[0.5, 1]"
                :size="[180, 180]"
              />
            </vl-style-box>
          </vl-feature>
        </vl-map>
      </div>
    </div>
  </loading>
</template>

<script>
import { DateTime } from "luxon";

import { userService } from "../_services";
import Loading from "./Loading.vue";
import { DateTimeFormats } from "../util/datetime.formats";

export default {
  components: { Loading },
  name: "TrackingTech",
  props: {
    locationId: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      coordinates: null,
      center: [],

      trackingTitle: "",
      zoom: 15,
      rotation: 0,

      drawType: null,
      drawnFeatures: null,
    };
  },
  watch: {
    locationId: function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }

      this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      if (!this.locationId || this.locationId === 0) {
        return;
      }

      this.coordinates = null;

      const data = await userService.getObject(
        null,
        "location",
        this.locationId,
      );
      const lastUpdate = DateTime.fromFormat(data.date_mod, DateTimeFormats.GLPI_DATETIME);
      const now = DateTime.now();

      if (now.diff(lastUpdate).as("minutes") < 10) {
        const lastUpdateString = lastUpdate.toFormat("dd/MM/yyyy");
        this.trackingTitle = `Técnico em deslocamento para atendimento do chamado (Última atualização: ${lastUpdateString})`;

        this.coordinates = [
          parseFloat(data.longitude),
          parseFloat(data.latitude),
        ];
        this.center = [...this.coordinates];
      } else {
        this.coordinates = [];
      }
    },
  },
};
</script>

<style scoped>
.map {
  height: 300px;
  width: 100%;
}
</style>
